import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CommentsSection from "components/Comments/CommentsSection";
import SolutionsSection from "components/Solutions/SolutionsSection";
import ImpactsSection from "components/Impacts/ImpactsSection";
import ActionsSection from "components/Actions/ActionsSection";
import IssueFeed from "components/Issues/IssueFeed";
import { Issue } from "util/constants";
import ScrollableTabsList from "ui/ScrollableTabsList";
import ScrollHideContainer from "ui/ScrollHideContainer";

interface Props {
    issue: Issue
    navigationOnly?: boolean
}

const IssueProfileTabs = ({ issue, navigationOnly = false }: Props) => {
    const { cname, tab, commentId } = useParams<{ cname: string; tab?: string; commentId?: string }>();
    const [selectedTab, setSelectedTab] = useState<string>(tab || "feed");

    // Update selectedTab when URL tab parameter changes
    useEffect(() => {
        if (commentId) {
            setSelectedTab("comments");
            return;
        }
        if (tab) {
            // Handle the mismatch between the route "actions" and the value "actions"
            if (tab === "actions") {
                setSelectedTab("actions");
            } else {
                setSelectedTab(tab);
            }
        } else {
            setSelectedTab("feed");
        }
    }, [tab, commentId]);

    const routeCname = issue.cname || cname || "";
    const encodedCname = encodeURIComponent(routeCname);
    const tabsData = [
        {
            label: "Discussion",
            route: `/issue/${encodedCname}/comments`,
            value: "comments",
        },
        {
            label: "Impacts",
            route: `/issue/${encodedCname}/impacts`,
            value: "impacts",
        },
        {
            label: "Solutions",
            route: `/issue/${encodedCname}/solutions`,
            value: "solutions",
        },
        {
            label: "Actions",
            route: `/issue/${encodedCname}/actions`,
            value: "actions",
        },
    ]

    /*if (issue.properties.type === 'Compound') {
        tabsData.splice(2, 1)
    }*/

    const tabsNav = (
        <ScrollHideContainer
            className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
            hideOffset={57}
            threshold={56}
        >
            <div className="issue-profile-tabs-nav p-2">
                <ScrollableTabsList
                    key={`issue-${routeCname}-tabs`}
                    tabs={tabsData}
                    selectedTab={selectedTab}
                    onTabChange={() => {}}
                    pageTitle={`Issue - ${issue.name}`}
                />
            </div>
        </ScrollHideContainer>
    )

    if (navigationOnly) {
        return tabsNav
    }

    return (
        <div className="issue-profile-tabs relative min-h-screen">
            {tabsNav}
            <div className="relative">
                {selectedTab === "feed" && <IssueFeed issue={issue} />}
                {selectedTab === "comments" && (
                    <CommentsSection
                        commentable_id={issue.id}
                        commentable_type="issue"
                        isEntitySection={true}
                    />
                )}
                {selectedTab === "impacts" && <ImpactsSection entityType="issue" entity={issue} sort="new" />}
                {selectedTab === "solutions" && (
                    <SolutionsSection issue={issue} />
                )}
                {selectedTab === "actions" && (
                    <ActionsSection
                        entity={issue}
                        entityType="issue"
                        sort="soonest"
                    />
                )}
            </div>
        </div>
    )
}

export default IssueProfileTabs
